import React from 'react';
import { LeafDivider, Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Indicar sin ficha técnica validada',
    cost: 'Inseguridad clínica que el paciente percibe'
  }, {
    without: 'Sin semáforo de seguridad por planta',
    cost: 'Riesgo real de indicar algo contraindicado'
  }, {
    without: 'Sin tabla de interacciones',
    cost: 'Paciente medicado en riesgo sin saberlo'
  }, {
    without: 'Sin protocolo por sistema',
    cost: 'Cada sesión construida desde cero, sin estructura'
  }, {
    without: 'Sin recetario de fórmulas',
    cost: 'Combinaciones improvisadas sin respaldo'
  }, {
    without: 'Sin dosificación pediátrica',
    cost: 'No sabes cómo ajustar para niños o adultos mayores'
  }, {
    without: 'Sin criterios de derivación',
    cost: 'No sabes cuándo la fitoterapia no es suficiente'
  }, {
    without: 'Sin ficha de consultorio',
    cost: 'Cada consulta sin registro ni continuidad real'
  }, {
    without: 'Sin guía de proveedores',
    cost: 'Materia prima de calidad desconocida'
  }, {
    without: 'Sin espagiria vegetal',
    cost: 'Pierdes pacientes que buscan preparaciones avanzadas'
  }, {
    without: 'Sin el sistema',
    cost: 'El mismo ciclo de incertidumbre, la próxima semana'
  }];
  return <Section data-id="element-18" data-mp="21m07mkhpvmc9">
      <div className="text-center mb-12" data-id="element-19" data-mp="21l8jfuqg8qw0">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[24px] text-brand-purpleDark" data-id="element-20" data-mp="26d9vbfjpgfli">
          <span className="mr-3" data-id="element-21" data-mp="1sn6dr1vrta2e">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-22" data-mp="1xm9l4sz83sdj">
        <div className="hidden md:block" data-id="element-23" data-mp="1xj3wtfyf4uiv">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-24" data-mp="1inflz7ylh960">
            <div className="font-serif font-bold text-lg text-brand-purple" data-id="element-25" data-mp="1iqa2wpiegbuo">
              Sin el Megapack Saberes Ancestrales
            </div>
            <div className="font-serif font-bold text-lg text-brand-burgundy" data-id="element-26" data-mp="14injiw96zho3">
              Costo real
            </div>
          </div>
          <div className="space-y-3" data-id="element-27" data-mp="zqe101aepjvu">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-burgundy/10 bg-white/70" data-id="element-28" data-mp="utduxqdk4h4q" data-mpi={i}>
                <div className="text-sm font-medium text-brand-text pr-4" data-id="element-29" data-mp="1ng8ac8vioqbc">
                  {row.without}
                </div>
                <div className="text-sm text-brand-burgundy/90 font-medium" data-id="element-30" data-mp="1iiycc4u2b6bw">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        <div className="md:hidden space-y-4" data-id="element-31" data-mp="18jh7tqqjqyhi">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-brand-burgundy/10 bg-white/70 space-y-2" data-id="element-32" data-mp="24zwxamgxkt6" data-mpi={i}>
              <p className="text-sm font-medium text-brand-text" data-id="element-33" data-mp="28s79mhmoae2s">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-brand-burgundy/90 font-medium" data-id="element-34" data-mp="2dr0ke2akrqz9">
                <span className="text-brand-burgundy shrink-0" data-id="element-35" data-mp="2iqmyedy89b94">→</span>
                <span className="text-sm" data-id="element-36" data-mp="2ioa9thxys2n3">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <LeafDivider className="mt-14" data-id="element-37" data-mp="2sgpqmbxiyl6e" />

      <div className="text-center" data-id="element-38" data-mp="2sfn1a8fuoqsl">
        <p className="text-xl md:text-2xl font-display italic font-[600] text-brand-purpleDark" data-id="element-39" data-mp="2sij1y4j31tkq">
          "El terapeuta que tiene un sistema aplica con confianza. El que aplica
          con confianza genera resultados. El que genera resultados, crece." 🌿
        </p>
      </div>
    </Section>;
};